import { Link } from "@tanstack/react-router";
import type { IconType } from "react-icons";
import {
  FiRefreshCw,
  FiSettings,
  FiSliders,
  FiTag,
  FiWatch,
} from "react-icons/fi";
import {
  PrimaryActionButton,
  type PrimaryActionButtonProps,
} from "@/shared/ui/navigation";

interface MobileCatalogFooterProps {
  ariaLabel?: string;
  isRefreshing: boolean;
  onOpenSort: () => void;
  onOpenTagFilter: () => void;
  onRefresh: () => void;
  primaryAction?: Omit<PrimaryActionButtonProps, "className">;
}

const itemClassName =
  "flex min-h-14 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-1 text-[0.6875rem] text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground disabled:cursor-not-allowed disabled:opacity-50";

function FooterItemContent({
  icon: Icon,
  label,
}: {
  icon: IconType;
  label: string;
}): React.ReactElement {
  return (
    <>
      <Icon className="h-5 w-5" aria-hidden="true" />
      {label}
    </>
  );
}

export function MobileCatalogFooter({
  ariaLabel = "カタログメニュー",
  isRefreshing,
  onOpenSort,
  onOpenTagFilter,
  onRefresh,
  primaryAction,
}: MobileCatalogFooterProps): React.ReactElement {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 flex items-center justify-around border-t border-border bg-card pb-[env(safe-area-inset-bottom)]"
      aria-label={ariaLabel}
    >
      {primaryAction && (
        <PrimaryActionButton
          {...primaryAction}
          className="absolute right-4 bottom-full mb-2"
        />
      )}
      <button type="button" className={itemClassName} onClick={onOpenSort}>
        <FooterItemContent icon={FiSliders} label="ソート" />
      </button>
      <button type="button" className={itemClassName} onClick={onOpenTagFilter}>
        <FooterItemContent icon={FiTag} label="フィルタ" />
      </button>
      <button
        type="button"
        className={itemClassName}
        aria-busy={isRefreshing}
        disabled={isRefreshing}
        onClick={onRefresh}
      >
        <FooterItemContent icon={FiRefreshCw} label="更新" />
      </button>
      <Link to="/archive" className={itemClassName}>
        <FooterItemContent icon={FiWatch} label="過去ログ" />
      </Link>
      <Link to="/settings" className={itemClassName}>
        <FooterItemContent icon={FiSettings} label="設定" />
      </Link>
    </nav>
  );
}
